import { Blob } from "../components/Blob";
import { Eyebrow } from "../components/Eyebrow";
import { WaitlistForm } from "../components/WaitlistForm";
import { copy } from "../content/copy";

export function FooterCta() {
  const c = copy.footerCta;
  return (
    <section className="section footer-cta">
      <Blob color="orange" position="bl" />
      <Blob color="lime" position="br" />
      {/* Anchor target sits inside the section's padding so #join lands the
          eyebrow right under the nav, not 100px below it. */}
      <div className="container footer-cta__inner" id="join">
        <Eyebrow>{c.eyebrow}</Eyebrow>
        <h2>
          We're building this with the <span className="serif-italic">first</span> teams who join.
        </h2>
        <p className="lede">{c.lede}</p>
        <div className="footer-cta__form-wrap">
          <WaitlistForm location="footer" />
        </div>
        <span className="footer-cta__privacy">{c.privacy}</span>
      </div>
    </section>
  );
}
